import { render, staticRenderFns } from "./call.vue?vue&type=template&id=14fb9724"
import script from "./call.vue?vue&type=script&lang=ts"
export * from "./call.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports